import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import { formatarDocument, onlyNumber } from '@iso/lib/helpers/utility';

const timeElapsed = Date.now();
const today = new Date(timeElapsed);

const styles = StyleSheet.create({
    reportTitle:{
        fontSize: 10,
        marginTop: 5,
        // fontWeight:'bold',
        fontFamily: 'Helvetica-Bold',
        textIndent:'5px'
    },
    fragmentContainer: {
        // marginTop: '15px',
        width: '100%',
        flexDirection: 'row',
        // height: 70,
        border: '1px solid #000000',
        borderRadius:'3px'
    },
    columnContainer: {
        borderRight: '1px solid #000000',
        padding: '2px',
        width: '80%'
    },
    label: {
        fontSize: 10,
        fontWeight: 'bold'
    },
    content: {
        fontSize: 10
    },
    dateContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        borderLeft: '1px solid #000000',
        width: '20%'
    },
    date: {
        fontSize: 10,
        fontStyle: 'bold'
    }
});

  const displayDocument = (val, rg_ie) => {
    let ret = '';
    if(typeof val !== 'undefined') {
        if(onlyNumber(val).length === 11) {
            ret = `CPF: ${formatarDocument(val)}, RG: ${rg_ie}`
        }
        else {
            ret = `CNPJ: ${formatarDocument(val)}, IE: ${((typeof rg_ie !== 'undefined') ? rg_ie : 'isento' )}`
        }
    }
    return ret;
  }

  const BillTo = ({title}) => (
    <>
        <Text style={styles.reportTitle}>Para:</Text>
        <View key={"container"} style={styles.fragmentContainer}>
            <View key={"collum"} style={styles.columnContainer}>
                <Text key={'company'} style={styles.label}>{`${title?.company}, ${displayDocument(title?.cpf_cnpj, title?.rg_ie)}`}</Text>
                <Text key={'address'} style={styles.label}>{title?.address}</Text>
                {/* <Text key={'name'} style={styles.label}>Nome: {title?.name}</Text> */}
                {/* <Text key={'cpf_cnpj'} style={styles.label}>{title?.cpf_cnpj}</Text> */}
                <Text key={'phone'} style={styles.label}>Fone: {title?.phone}, {title?.email}</Text>
                {/* <Text key={'fone'} style={styles.label}>Telefone: {title?.fone}</Text> */}
                {/* <Text key={'email'} style={styles.label}>{title?.email}</Text> */}
                {/* {(title?.address)
                    ? 
                    <Text key={'address'} style={styles.label}>{title.address?.cep}, {title.address?.city} - {title.address?.state} </Text>
                    : ''} */}
            </View>
            <View key={"collumDate"} style={styles.dateContainer}>
                <Text style={styles.date}>{`Data: ${today.toLocaleDateString()}`}</Text>
            </View>
        </View>
   </>
  );
  
  export default BillTo